import { useQuery } from '@apollo/client';
import {
    GET_HUB_WAREHOUSE_DSP_OPTIONS,
    HubWarehouseDspOptionsResponse
} from '../graphql/queries/getHubWarehouseDspOptions';

export interface WarehouseDspOption {
    id: number;
    name: string;
}

/**
 * Hub 结构关联的仓库与 DSP 选项 Hook（daily-task 与 SLA 两个 hub 页面共用）。
 * - warehouses：hub 下子仓库，不随 warehouseIds 变化（后端始终返回 hub 全部子仓库）。
 * - dsps：selectedWarehouseIds 非空时按所选仓库级联过滤，否则取 hub 下全部子仓库关联的 DSP。
 * 与日期无关：cache-first 缓存，日期切换不重查；仅 WHS 选择变化时带 warehouseIds 重查 DSP。
 */
export const useHubWarehouseDspOptions = (
    hubId?: number,
    selectedWarehouseIds?: string[]
): {
    warehouses: WarehouseDspOption[];
    dsps: WarehouseDspOption[];
    loading: boolean;
    error: unknown;
    refetch: unknown;
} => {
    const warehouseIds = selectedWarehouseIds && selectedWarehouseIds.length > 0
        ? selectedWarehouseIds
            .map((id) => parseInt(String(id), 10))
            .filter((n) => !Number.isNaN(n))
        : undefined;

    const { data, loading, error, refetch } = useQuery<HubWarehouseDspOptionsResponse>(
        GET_HUB_WAREHOUSE_DSP_OPTIONS,
        {
            variables: { hubId, warehouseIds },
            skip: hubId == null,
            fetchPolicy: 'cache-first',
            errorPolicy: 'all',
            notifyOnNetworkStatusChange: false
        }
    );

    return {
        warehouses: data?.getHubWarehouseDspOptions?.warehouses || [],
        dsps: data?.getHubWarehouseDspOptions?.dsps || [],
        loading,
        error,
        refetch
    };
};
